import { RotateCcw } from "lucide-react";
import { productTone } from "@/lib/productTone";

const FIELDS = [
    ["pd_bg_color", "Sfondi i faqes", "#ffffff"],
    ["pd_panel_color", "Panelet (foto, tabela)", "#f8fafc"],
    ["pd_text_color", "Teksti kryesor", "#0f172a"],
    ["pd_border_color", "Vijat / kornizat", "#e2e8f0"],
    ["pd_accent_color", "Ngjyra theksuese (vetëm këtu)", "#f97316"],
];
const PRESETS = [
    ["Standard", {}],
    ["E ngrohtë", { pd_bg_color: "#fffbf5", pd_panel_color: "#fdf3e6", pd_text_color: "#1c1917", pd_border_color: "#eadbc8" }],
    ["E ftohtë", { pd_bg_color: "#f8fbff", pd_panel_color: "#eef4fb", pd_text_color: "#0b1b33", pd_border_color: "#d6e2f0" }],
    ["Çeliku", { pd_bg_color: "#f1f3f5", pd_panel_color: "#e3e7eb", pd_text_color: "#111827", pd_border_color: "#cbd2d9" }],
];

export default function ProductToneSection({ content, updateField }) {
    const reset = Object.fromEntries(FIELDS.map(([k]) => [k, ""]));
    return (
        <section className="border-t border-slate-200 pt-6" data-testid="theme-product-tone">
            <div className="label-kicker text-slate-500 mb-1">Faqja e produktit · tonaliteti i ngjyrave</div>
            <p className="text-xs text-slate-500 mb-3">Lëre bosh që të përdoret ngjyra standarde.</p>
            <div className="flex flex-wrap gap-2 mb-4">
                {PRESETS.map(([label, vals]) => (
                    <button key={label} type="button" onClick={() => updateField({ ...reset, ...vals })} className="btn-outline !py-1 !text-xs" data-testid={`pd-tone-preset-${label.toLowerCase().replace(/\s/g, "-")}`}>
                        <span className="w-3 h-3 border border-slate-300" style={{ background: vals.pd_panel_color || "#f8fafc" }} /> {label}
                    </button>
                ))}
            </div>
            <div className="grid md:grid-cols-[1fr_1fr] gap-6">
                <div className="space-y-2">
                    {FIELDS.map(([key, label, def]) => (
                        <div key={key} className="flex items-center gap-3">
                            <input type="color" value={content[key] || def} onChange={(e) => updateField({ [key]: e.target.value })} className="w-10 h-8 border border-slate-300 cursor-pointer" data-testid={`pd-color-${key}`} />
                            <span className="text-sm flex-1">{label}</span>
                            <span className="font-mono text-[10px] text-slate-500 w-16">{content[key] || "standard"}</span>
                            {content[key] && (
                                <button type="button" onClick={() => updateField({ [key]: "" })} className="p-1 text-slate-500 hover:text-red-600" title="Kthe standard" data-testid={`pd-color-reset-${key}`}>
                                    <RotateCcw className="w-3.5 h-3.5" />
                                </button>
                            )}
                        </div>
                    ))}
                </div>
                <div className="pd-themed border p-4 border-slate-200" style={productTone(content)} data-testid="pd-tone-preview">
                    <div className="font-mono text-[10px] text-slate-500 mb-2">PAMJA PARAPRAKE</div>
                    <div className="flex gap-3">
                        <div className="w-24 h-24 bg-slate-50 border border-slate-200" />
                        <div className="flex-1">
                            <div className="font-display font-black uppercase text-slate-900">GT1749V 454231</div>
                            <div className="text-xs text-[hsl(var(--primary))] font-bold mt-1">€ 420.00</div>
                            <table className="w-full text-xs mt-2 border border-slate-200">
                                <tbody>
                                    <tr className="border-b border-slate-200"><td className="px-2 py-1 bg-slate-50 text-slate-500">Kategoria</td><td className="px-2 py-1 text-slate-900">TURBOCHARGER</td></tr>
                                    <tr><td className="px-2 py-1 bg-slate-50 text-slate-500">Stoku</td><td className="px-2 py-1 text-slate-900">Në stok</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
